import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'

import en from 'vuetify/es5/locale/en'
import ru from 'vuetify/es5/locale/ru'

import yClientsIcon from '@/assets/vuetifyIcons/yClients.vue'
import yClientsActiveIcon from '@/assets/vuetifyIcons/yClientsActive.vue'
import whatsappIcon from '@/assets/vuetifyIcons/whatsapp.vue'
import telegramIcon from '@/assets/vuetifyIcons/telegram.vue'
import whatsappActiveIcon from '@/assets/vuetifyIcons/whatsappActive.vue'
import profSalonIcon from '@/assets/vuetifyIcons/profSalon.vue'
import altegioIcon from '@/assets/vuetifyIcons/altegio.vue'
import sonlineIcon from '@/assets/vuetifyIcons/sonline.vue'
import profSalonActiveIcon from '@/assets/vuetifyIcons/profSalonActive.vue'
import dikidiIcon from '@/assets/vuetifyIcons/dikidi.vue'
import radioButtonCheckedIcon from '@/assets/vuetifyIcons/radioButtonChecked.vue'
import radioButtonUncheckedIcon from '@/assets/vuetifyIcons/radioButtonUnchecked.vue'
import googleAuthIcon from '@/assets/vuetifyIcons/googleAuth.vue'
import amoCrmIcon from '@/assets/vuetifyIcons/amoCrm.vue'
import clientsIcon from '@/assets/vuetifyIcons/clients.vue'
import resetArrowIcon from '@/assets/vuetifyIcons/resetArrow.vue'
import analyticsIcon from '@/assets/vuetifyIcons/analytics.vue'
import moneyIcon from '@/assets/vuetifyIcons/money.vue'
import greenGradientCheckmarkIcon from '@/assets/vuetifyIcons/greenGradientCheckmark.vue'
import yellowGradientWarningIcon from '@/assets/vuetifyIcons/yellowGradientWarning.vue'
import redGradientLightningIcon from '@/assets/vuetifyIcons/redGradientLightning.vue'
import marketplaceIcon from '@/assets/vuetifyIcons/marketplace.vue'
import ChatIcon from '../assets/vuetifyIcons/chat.vue'
import CloseIcon from '../assets/vuetifyIcons/close.vue'
import CloseRoundedIcon from '../assets/vuetifyIcons/closeRounded.vue'
import FrameIcon from '../assets/vuetifyIcons/frame.vue'
import StapleIcon from '../assets/vuetifyIcons/staple.vue'
import CopyIcon from '../assets/vuetifyIcons/copy.vue'
import SpinArrowsIcon from '../assets/vuetifyIcons/spinArrows.vue'
import ArrowRightXsIcon from '../assets/vuetifyIcons/arrowRightXs.vue'
import MagnifyIcon from '../assets/vuetifyIcons/magnify.vue'
import DragOutlineIcon from '../assets/vuetifyIcons/dragOutline.vue'
import marketingReportIcon from '@/assets/vuetifyIcons/marketingReport.vue'
import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, { directives: { Ripple } })
import colors from 'vuetify/lib/util/colors'
export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                main: '#378EFF',
                mainDark: '#2A3B51',
                textColor: '#465468',
                lightGray: '#bfbfbf',
                primary: '#378EFF',
                success: '#00b74f',
                red: '#E20029',
                mainNew: '#525AD5',
                popNew: '#D4EC38',
                darkNew: '#1A1A2E',
                secondaryNew: '#29A4AB',
                alertNew: '#E8183C',
                ghostNew: '#D8EFFD',
                bcgCardNew: '#EEF0FF',
                textColorNew: '#1A2040',
                mutedNew: '#7A849A',
                borderNew: '#E2E6EF',
                borderHoverNew: '#BBC8F0',
                navyNew: '#1E2235',
            },
            dark: { main: '#378EFF' },
        },
    },
    iconfont: 'mdiSvg',
    icons: {
        values: {
            arrowRightXs: {
                component: ArrowRightXsIcon as any,
            },
            yClients: {
                component: yClientsIcon as any,
            },
            yClientsActive: {
                component: yClientsActiveIcon as any,
            },
            telegram: {
                component: telegramIcon as any,
            },
            whatsapp: {
                component: whatsappIcon as any,
            },
            whatsappActive: {
                component: whatsappActiveIcon as any,
            },
            profSalon: {
                component: profSalonIcon as any,
            },
            altegio: {
                component: altegioIcon as any,
            },
            profSalonActive: {
                component: profSalonActiveIcon as any,
            },
            sonline: {
                component: sonlineIcon as any,
            },
            dragOutline: {
                component: DragOutlineIcon as any,
            },
            dikidi: {
                component: dikidiIcon as any,
            },
            amoCrm: {
                component: amoCrmIcon as any,
            },
            googleAuth: {
                component: googleAuthIcon as any,
            },
            radioButtonChecked: {
                component: radioButtonCheckedIcon as any,
            },
            radioButtonUnchecked: {
                component: radioButtonUncheckedIcon as any,
            },
            clients: {
                component: clientsIcon as any,
            },
            analytics: {
                component: analyticsIcon as any,
            },
            marketingReport: {
                component: marketingReportIcon as any,
            },
            money: {
                component: moneyIcon as any,
            },
            greenGradientCheckmark: {
                component: greenGradientCheckmarkIcon as any,
            },
            yellowGradientWarning: {
                component: yellowGradientWarningIcon as any,
            },
            redGradientLightning: {
                component: redGradientLightningIcon as any,
            },
            magnify: {
                component: MagnifyIcon as any,
            },
            marketplace: {
                component: marketplaceIcon as any,
            },
            chat: {
                component: ChatIcon as any
            },
            reset: {
                component: resetArrowIcon as any
            },
            close: {
                component: CloseIcon as any
            },
            closeRounded: {
                component: CloseRoundedIcon as any
            },
            spinArrows: {
                component: SpinArrowsIcon as any
            },
            frame: {
                component: FrameIcon as any
            },
            staple: {
                component: StapleIcon as any
            },
            copy: {
                component: CopyIcon as any
            },
        },
    },

    lang: {
        locales: { en, ru },
        current: 'ru',
    },
})
